import React, { useEffect, useState } from "react";

import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  Button,
  Col,
  Row,
  RSelect
} from "../../components/Component";
import { GET, POST, PUT } from "../../helper/api";
import { formatDateYMD, getDefaultTransactionHistory } from "../../utils/Utils";
import UpsertTransactionHistoryComponent from './upserttransactionhistorycomponent/UpsertTransactionHistoryComponent';
import { buildLabelMortgageContract } from "../../helper/mortgage-contract";

const UpsertTransactionHistory = ({ type, id, defaultValue = {}, onClose }) => {
  const methodForm = useForm({
    defaultValues: getDefaultTransactionHistory(defaultValue),
  });

  const {
    reset,
    getValues,
    watch,
    register,
    errors,
    control,
    handleSubmit,
  } = methodForm
  const editId = id !== "add" ? id : undefined;
  const [userOptions, setUserOptions] = useState([]);
  const [showFormRequestUpdate, setShowFormRequestUpdate] = useState(false);
  const [haveRequestUpdate, setHaveRequestUpdate] = useState(null);
  const [defaultMortgageContractOption, setSefaultMortgageContractOption] = useState([]);

  useEffect(() => {
    GET("/user/list-can-confirm-request-update", {}, true).then((resp) => {
      setUserOptions(
        resp.data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });

    if (editId) {
      GET(`/transaction-history/${id}`, {}, true).then((resp) => {
        const { haveRequestUpdate } = resp.data

        if (haveRequestUpdate) {
          setHaveRequestUpdate(haveRequestUpdate)
        }
        reset(resp.data);

        if (resp.data.contractId) {
          const c = resp.data.mortgageContract;
          setSefaultMortgageContractOption([{
            label: buildLabelMortgageContract(c),
            value: c.contractId,
            data: c,
          }]);
        }
      });
    }
  }, [])

  const parseDataSubmit = (payload) => {
    const {
      address,
      amount,
      bankAccountId,
      categoryId,
      content,
      date,
      receiver,
      contractId,
      fund,
      fundUSD,
      interest,
      interestUSD,
      exchangeInterestRate,
      exchangeRate,
      amountUSD,
      currency,
      reason,
      reviewerId,
      hookTransactionHistoryId,
    } = payload;

    const formData = {
      amount,
      bankAccountId,
      categoryId,
      content,
      receiver,
      address,
      date: moment(date).format(formatDateYMD),
      type,
      hookTransactionHistoryId: hookTransactionHistoryId ? Number(hookTransactionHistoryId) : null,
      exchangeRate,
      amountUSD,
      currency,
      contractId: contractId || null,
      fundUSD,
      interestUSD,
      exchangeInterestRate,
      ...(contractId ? {
        fund,
        interest,
      } : {}),
      reason,
      reviewerId,
    };
    return formData;
  }
  // Submits form data
  const onHandleSubmit = () => {
    const formData = parseDataSubmit(getValues())

    const request = editId
      ? PUT(`transaction-history/${editId}`, formData, {}, true)
      : POST("transaction-history", formData, {}, true);

    request
      .then(() => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        if (onClose) {
          onClose();
        }
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
  };

  const onRequestUpdate = () => {
    const formData = parseDataSubmit(getValues());
    PUT(`/transaction-history/request-update/${id}`, formData, {}, true)
      .then((res) => {
        toast.success("Gửi yêu cầu thành công");
        if (onClose) {
          onClose();
        }
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại.");
      })
  };

  return (
    <div className="card card-bordered card-preview">
      <div className="card-inner">
        <h3>
          {!editId ? "Thêm" : "Sửa"} tiền {type === "IN" ? "thu" : "chi"}

        </h3>
        <FormProvider {...methodForm}>
          <UpsertTransactionHistoryComponent defaultMortgageContractOptions={defaultMortgageContractOption} type={type} />
          <div>
            <Col md="12">
              {showFormRequestUpdate ? (
                <Row>

                  <Col md="6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="customer">
                        Người duyệt
                        <span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <Controller
                          control={control}
                          name="reviewerId"
                          rules={{ required: "Vui lòng nhập thông tin" }}
                          render={({ onChange, value, name, ref }) => (
                            <RSelect
                              classNamePrefix="form-control"
                              inputRef={ref}
                              name={name}
                              options={userOptions}
                              value={userOptions.find(
                                (c) => c.value === value
                              )}
                              onChange={(val) => onChange(val.value)}
                            />
                          )}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="reviewerId"
                          render={({ message }) => (
                            <span className="invalid">{message}</span>
                          )}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col size="12">
                    <div className="form-group">
                      <label className="form-label" >
                        Lý do cập nhật<span className="text-danger">*</span>
                      </label>
                      <div className="form-control-wrap">
                        <textarea
                          rows={3}
                          className="form-control"
                          style={{ height: "unset" }}
                          name="reason"
                          ref={register({
                            required: "Vui lòng nhập thông tin",
                          })}
                          disabled={haveRequestUpdate}
                        />
                        <ErrorMessage errors={errors} name="reason" render={({ message }) => <span className="invalid">{message}</span>} />
                      </div>
                      <div className="mt-2">
                        <Button disabled={haveRequestUpdate} color="primary" type="button" className={"mr-2"} onClick={handleSubmit(onRequestUpdate)}>
                          <span>Gửi yêu cầu cập nhật</span>
                        </Button>
                        <Button color="primary" type="button" onClick={() => setShowFormRequestUpdate(false)}>
                          <span>Ẩn yêu cầu sửa thu chi</span>
                        </Button>

                      </div>
                    </div>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col size="12" className={"mt-4"}>
                    <Button color="primary" type='button' className={`mr-2`} onClick={handleSubmit(onHandleSubmit)}>
                      <span>Lưu giao dịch</span>
                    </Button>
                    {
                      editId ? <Button color="primary" type="button" onClick={() => setShowFormRequestUpdate(true)}>
                        <span>Hiện yêu cầu sửa thu chi</span>
                      </Button> : <></>
                    }
                  </Col>
                </Row>
              )}

            </Col>
          </div>
        </FormProvider>


      </div>
    </div>
  );
};

export default UpsertTransactionHistory;
